import React, { PropsWithChildren } from 'react';
import { classnames } from '@ygtechnologies/bygr-frontend-component-library';

import { TranslatableText } from '@/types';

import { ValidatingSelect } from '@/components/forms/validation';

import theme from './UserPageInput.module.scss'; // reuse same css module as UserPageInput

interface WrapperProps extends PropsWithChildren {
    label: TranslatableText;
}

export const UserPageSelectWrapper: React.FC<WrapperProps> = ({ label, children }) => {
    return (
        <label className={theme.container}>
            <span>{label}</span>
            {children}
        </label>
    );
};

interface ValidatingSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {}

type OwnProps = ValidatingSelectProps & WrapperProps;

const UserPageSelect = React.forwardRef<HTMLSelectElement, OwnProps>(({ label, children, ...selectProps }, ref) => {
    return (
        <UserPageSelectWrapper label={label}>
            <div className={theme.inputContainer}>
                <ValidatingSelect {...selectProps} className={classnames(theme.inputSpacing, 'form-control')} ref={ref}>
                    {children}
                </ValidatingSelect>
            </div>
        </UserPageSelectWrapper>
    );
});

export default UserPageSelect;
